import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cx from 'classnames';
import { CatTextLink } from '@blocks-react/components/TextLink';
export const LinkWithIcon = ({ icon, children, href, target, linkClassName, linkTextClassName, ariaLabel, }) => {
    return (_jsxs(CatTextLink, { href: href, target: target, className: cx('d-flex align-items-center', linkClassName), "aria-label": ariaLabel, children: [_jsx("div", { className: "d-flex align-items-center me-2", children: icon }), _jsx("span", { className: cx(linkTextClassName, 'restart-global'), children: children })] }));
};
